import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="change-questions"
export default class extends Controller {

    connect(){
    }

    submitFormForChangeQuestion(e) {
        e.preventDefault();
        const questionNumber = e.target.dataset.ascertainTestQuestionNumber;
        const formElement = document.getElementById('ascertain_test_form');
        // 隠しフィールドに問題の変更をしようとしているフラグと変更遷移先の問題番号を設定
        if (formElement) {
            formElement.querySelector('#button_field').value = "change_question";
            formElement.querySelector('#change_question_field').value = questionNumber;
            formElement.submit();
        } else {
            console.error("Form not found");
        }
    }

}